import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'text', 'image', 'imageWrapper']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "text" | "image" | "imageWrapper")[]
 * }>} LinkStyles
 */

export const linkStyles = helpers.defineMultiStyleConfig({
  /**
   * Base styles for Link component
   *
   * @param {Object} args - Component arguments
   * @param {Contentful.Link} args.component - Link component data
   * @param {string} [args.type] - Link type variant
   *
   * @returns {LinkStyles} - Component styles
   */
  baseStyle({component, type}) {
    return {
      root: {
        display: 'inline-block',
        textDecoration: 'none',
      },
      text: {},
      imageWrapper: {
        display: 'inline-block',
      },
      image: {
        maxWidth: '100%',
        maxHeight: '100%',
        display: 'block',
      },
    };
  },

  variants: {
    default: {
      root: {
        _hover: {
          textDecoration: 'underline',
        },
      },
    },
    card: {
      root: {
      },
    },
  },
});
